import axios, { isAxiosError } from 'axios';
import { useSession } from '../../composables/useSession';
import { randomUUID } from 'uncrypto';

export async function getSearchResults({
  term,
  secondaryOrgId,
  searchByCurrentOrg,
  selectedFilters,
  orgIds = null,
  startDate = null,
  endDate = null,
  locale,
}: {
  term: string;
  secondaryOrgId: string;
  searchByCurrentOrg: boolean;
  selectedFilters: string[];
  orgIds: string[] | null;
  startDate: string | null;
  endDate: string | null;
  locale: string | undefined;
}) {
  try {
    // Get values internally instead of requiring them as parameters
    const { value: token } = useCookie('auth-token');
    const writableApi = useRuntimeConfig().public.WRITABLE_BASE_API_URL;
    const { sessionId } = useSession(secondaryOrgId);
    const queryId = randomUUID();

    const searchAPI = `${writableApi}api/v4/o/${secondaryOrgId}/cms/search`;
    const headers = token ? { Authorization: `${token}` } : {};

    const params = {
      q: term,
      query_id: queryId,
      session_id: sessionId.value,
      ...(orgIds ? { secondary_organizations: orgIds } : {}),
      ...(searchByCurrentOrg ? { secondary_organizations: [secondaryOrgId] } : {}),
      ...(selectedFilters?.length > 0 ? { query_indices: selectedFilters } : {}),
      ...(startDate ? { start_date: startDate } : {}),
      ...(endDate ? { end_date: endDate } : {}),
      ...(locale ? { locale } : {}),
    };

    const response = await axios.get(searchAPI, {
      headers: {
        ...headers,
      },
      params,
    });

    return response;
  } catch (e) {
    if (isAxiosError(e)) {
      console.error('Search API Error:', e);
      console.error('Error details:', {
        status: e.response?.status,
        statusText: e.response?.statusText,
        data: e.response?.data,
        url: e.config?.url,
        params: e.config?.params,
      });
    } else {
      console.error('Search API Error:', e);
    }
    return { data: { results: [] } };
  }
}
